import { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { router } from './routes'
import { Loader } from '@/shared/components/Loader/Loader'

/**
 * Root App Component
 *
 * This component is kept minimal and only handles routing.
 * All page content is handled by feature-based page components.
 *
 * Performance: Suspense boundary for lazy-loaded routes
 */
function App() {
  return (
    <Suspense
      fallback={
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}
        >
          <Loader text="Loading application..." />
        </div>
      }
    >
      <NuqsAdapter>
        <RouterProvider router={router} />
      </NuqsAdapter>
    </Suspense>
  )
}

export default App
